export default ".legend {\n  font-size: medium;\n}";